export default __webpack_public_path__ + "static/media/softingal.d5715a28.png";